<template>
  <svg width="17" height="11" viewBox="0 0 17 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.71875 8.66919L8.49371 0.894236L10.615 3.01556L10.4674 3.16246L16.1795 8.8738L14.0582 10.9951L8.34641 5.28446L2.84007 10.7905L0.71875 8.66919Z" fill="white"/>
  </svg>
</template>